export default "__VITE_PUBLIC_ASSET__1587e89f__"